export class ViewEdit
{
    public id = null;
    public version = null;
    public name = '';
    public viewName = '';
    public viewType = null;
    public authorizedRoles = [];
    public numerator = null;    
}
